<script setup lang="ts"></script>

<template>
  <div class="mb-6 flex flex-wrap text-xs items-end xl:mb-4 sm:text-sm">
    <slot></slot>
  </div>
</template>
